import {
	Backdrop,
	Box,
	CircularProgress,
	Divider,
	IconButton,
	List,
	ListItem,
	ListSubheader,
	makeStyles,
	Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import React, { useEffect, useState } from "react";

import { EventTracking } from "../../../../src/utilities/Tracking/EventTracking";
import { useBuilderDrawer } from "./useBuilderDrawer";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { AssistantSection } from "./components/assistantSection";
import { AssistantMode } from "../../../services/AssistantService";

export const useStyles = makeStyles((theme) => ({
	title: {
		padding: "10px 16px 7px 16px",
		textAlign: "left",
		fontSize: 22,
		backgroundColor: "white",
	},
	subtitle: {
		fontSize: 12,
		paddingTop: 10,
		paddingBottom: 10,
		textAlign: "center",
	},
	closeIcon: {
		float: "right",
	},
}));

export function Assistant() {
	const classes = useStyles();
	const builderDrawer = useBuilderDrawer();

	const [expandedSection, setExpandedSection] = useState<"getStarted" | "feelingStuck" | "analyze">();
	const [suggestions, setSuggestions] = useState<string>();

	const [hubConnection, setHubConnection] = useState<HubConnection | null>(null);

	const hubConnectionReady = hubConnection !== null && hubConnection.state === "Connected";

	useEffect(() => {
		const connection = new HubConnectionBuilder().withUrl("/ai-chat").withAutomaticReconnect().build();
		connection.on("Message", (message: string) => {
			console.log(message);
		});
		setHubConnection(connection);
	}, []);

	useEffect(() => {
		if (hubConnection)
			hubConnection.start()
				.then(() => console.log("Connection started!"))
				.catch((err) => console.log(err));

		return () => {
			if (hubConnection)
				hubConnection.stop()
					.then(() => console.log("Connection stopped!"))
					.catch((err) => console.log(err));
		};
	}, [hubConnection]);

	const resetConnection = async () => {
		if (hubConnection) {
			try {
				await hubConnection.stop();
				await hubConnection.start();
				console.log("Connection reset!");
			} catch (err) {
				console.log(err);
			}
		}
	}

	const handleSectionClick = (section: "getStarted" | "feelingStuck" | "analyze"): void => {
		if (expandedSection === section) setExpandedSection(undefined);
		else setExpandedSection(section);
	};

	const onClose = () => {
		EventTracking.Builder.onCloseMainDrawerFromX();
		builderDrawer.onMainDrawerChange(false);
	};

	return (
		<List style={{padding: 0, overflowX: "hidden"}}>
			<ListSubheader style={{ padding:0, zIndex: 2 }}>
				<Box className={classes.title}>
					AI Assistant
					<IconButton onClick={onClose} className={classes.closeIcon}>
						<CloseIcon />
					</IconButton>
				</Box>
				
				<Divider />
			</ListSubheader>
			
			<Box height="55px">
				<ListItem>
					{hubConnectionReady && 
						<Typography className={classes.subtitle}>Help to research & prepare your sermon</Typography>
					}
					{!hubConnectionReady &&
						<>
							<CircularProgress style={{}} />
							<Typography style={{marginLeft: 12}}>
								Connecting...
							</Typography>
						</>
					}


				</ListItem>
				<Divider />
			</Box>
			
			<Box position="relative">
				<Backdrop open={!hubConnectionReady} style={{position: "absolute", zIndex: 4}} />

				<AssistantSection
					sectionMode={AssistantMode.GetStarted}
					expand={expandedSection === "getStarted"}
					onExpand={() => handleSectionClick("getStarted")}
					hubConnection={hubConnection!}
					resetConnection={resetConnection}
				/>

				<AssistantSection
					sectionMode={AssistantMode.FeelingStuck}
					expand={expandedSection === "feelingStuck"}
					onExpand={() => handleSectionClick("feelingStuck")}
					hubConnection={hubConnection!}
					resetConnection={resetConnection}
				/>

				<AssistantSection
					sectionMode={AssistantMode.Analyze}
					expand={expandedSection === "analyze"}
					onExpand={() => handleSectionClick("analyze")}
					hubConnection={hubConnection!}
					resetConnection={resetConnection}
				/>
			</Box>
		</List>
	);
}


